import { useNavigate, Link as RouterLink } from 'react-router-dom'
import { Button, Card, CardMedia, Grid, Link, Typography } from '@mui/material'

import { IImpactLibraryDtoWithId } from 'src/types'
import { useStyles } from './styles'
import { LinkIcon } from 'src/assets/icons'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IItemsListProps {
  items?: IImpactLibraryDtoWithId[] | void
}

const ItemsList = ({ items }: IItemsListProps) => {
  const classes = useStyles()
  const navigate = useNavigate()

  const handleSelect = (id: string) => () => {
    navigate(`add?libraryDuplicate=${id}`)
  }

  return (
    <Grid container className={classes.itemsListWrapper}>
      {items?.map((item) => (
        <Grid key={item.id} item>
          <Card className={classes.itemWrapper}>
            <div className={classes.itemImage}>
              <CardMedia
                component={'img'}
                className={classes.itemImage}
                image={item.image_small || item.image}
                alt={item.name}
              />
            </div>
            <div className={classes.itemContent}>
              <div className={classes.itemText}>
                <Typography className={classes.itemName} component="h4">
                  {item.name}
                </Typography>
                {item.url && (
                  <>
                    <Link
                      className={classes.rowUrlLink}
                      target="_blank"
                      component={RouterLink}
                      to={item.url}
                    >
                      <HelperWrapper t="account-form-website-input-label" />
                      <LinkIcon className={classes.urlIcon} />
                    </Link>
                  </>
                )}
              </div>
              <div>
                <Button
                  size="small"
                  type="button"
                  variant="contained"
                  color="secondary"
                  className={`${classes.impactsLibraryButton} ${classes.selectImpactButton}`}
                  onClick={handleSelect(item.id)}
                >
                  <HelperWrapper t="select-button-text" />
                </Button>
              </div>
            </div>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}

export { ItemsList }
